/**
 * Desktop (Electron) offline SQLite is scoped by company so we do not mix
 * customers/products synced from different backends (e.g. local vs prod).
 */
export function getDesktopOfflineCompanyId() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const id = user?.company?.id ?? user?.companyId;
    if (id == null || id === '') return null;
    const n = Number(id);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}
